var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center p-[2px]"},[(_vm.customs.image.src)?_c('img',{style:({height: _vm.imageSize}),attrs:{"src":_vm.customs.image.src}}):(_vm.customs.text)?_c('div',{style:(_vm.styles)},[_vm._v(" "+_vm._s(_vm.customs.text)+" ")]):_c('div',{staticClass:"logo-placeholder"})])
}
var staticRenderFns = []

export { render, staticRenderFns }